var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#E7F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6103 30.2169C67.8072 29.1513 70.8487 32.1928 69.7831 35.3897L59.1786 67.2032C58.0595 70.5605 53.4934 71.0078 51.7441 67.9314L45.9796 57.7939L52.4446 51.3289C53.4862 50.2873 53.4862 48.5986 52.4446 47.557C51.403 46.5154 49.7143 46.5154 48.6727 47.557L42.2081 54.0215L32.0686 48.2559C28.9922 46.5066 29.4395 41.9405 32.7968 40.8214L64.6103 30.2169Z",
    fill: "#169CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSend);
export default __webpack_public_path__ + "static/media/modal_send.03d92a8f5244588a775cc1f9477302ec.svg";
export { ForwardRef as ReactComponent };